module.exports = __webpack_public_path__ + "img/expand-04.2f3446dc.svg";